<template>
  <div>
    <div class="vx-row">
      <!-- COL 1 -->
      <div class="vx-col w-full lg:w-1/2">

        <div class="uuuuuuuuuuuuuuuuuuuuu">
          <div v-if="!loading">
            <div class="post-header flex justify-between mb-3">

              <div class="flex items-center">

                <div class="ml-4">
                  <h2 style="font-size: 20px;  font-weight: 600;   margin-top: 0;">Statistiques: {{
                    message.title }}</h2>
                </div>
              </div>
            </div>

            <vs-divider style="height: 2px" background="primary"></vs-divider>

            <div>
              <vs-list>


                <vs-list-item title="Créé le">
                  <small style="color: #005A99">{{message.created_at}}</small>
                </vs-list-item>

                <vs-list-item title="Etat">
                  <small style="color: #005A99">{{message.state ? 'Actif' : 'Inactif'}}</small>
                </vs-list-item>

                <vs-list-item title="Nombre de vues">
                  <small style="color: #005A99">{{message.message_users ? message.message_users.length : 0}} sur {{total_users}}</small>
                </vs-list-item>

              <vs-list-item title="Statistiques">
                <br>
                <div v-if="!loading">
                  <apexchart width="380" type="donut" :options="options" :series="series"></apexchart>
                </div>
              </vs-list-item>
              </vs-list>
            </div>

          </div>
        </div>

      </div>

      <div class="vx-col w-full lg:w-1/2">
        <div class="ddddddddd">
          <vs-list>
            <vs-list-header title="Utilisateurs ayant lu le message" color="primary"></vs-list-header>
            <div v-if="message.message_users && message.message_users.length > 0">
              <vs-table :data="message.message_users" pagination>

                <template slot="thead">
                  <vs-th>Message</vs-th>
                  <vs-th>Utilisateur</vs-th>
                  <vs-th>Date de lecture</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].message_id">
                      {{ message.title }}
                    </vs-td>

                    <vs-td :data="data[indextr].user">
                      {{ data[indextr].user.lastname + " " + data[indextr].user.firstname}}
                    </vs-td>

                    <vs-td :data="data[indextr].created_at">
                      {{ data[indextr].created_at }}
                    </vs-td>
                  </vs-tr>
                </template>

              </vs-table>
            </div>
          </vs-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "show",
    data: () => ({
      loading: false,
      message: {},
      total_users: 0,
      options: {
        labels: ["Utilisateurs ayant lu", "Utilisateurs n'ayant pas lu"],
        theme: {
          monochrome: {
            enabled: true,
            color: "#005A99",
          },
        },
      },
      series: []
    }),
    watch: {},
    methods: {
      loadMessageData() {
        this.loading = true
        this.$vs.loading()
        let message_slug = this.$route.params.slug;

        this.$http.get("messages/" + message_slug, {
          headers: {'Authorization': 'Bearer ' + localStorage.getItem('accessToken')}
        }).then(response => {
          this.loading = false
          this.$vs.loading.close()
          this.message = response.data.message
          this.total_users = response.data.total_users
          this.series = [response.data.vues, response.data.not_vues]
        }).catch(error => {
          this.loading = false
          this.$vs.loading.close()
          console.log("error " + JSON.stringify(error))
        });
      }
    },
    created() {
      this.loadMessageData()
    }
  }
</script>

<style scoped>

</style>
